import { Container, ContainerProps } from '@mui/material';

import containerTheme from './Container';

export default Container;
export { Container, containerTheme };
export type { ContainerProps };
